module.exports = __webpack_public_path__ + "img/diary_v2_tab.26005133.jpg";